import { useEffect, useRef } from "react";

export function useAbortController(): AbortController {
  const abortControllerRef = useRef<AbortController>();
  if (!abortControllerRef.current) {
    abortControllerRef.current = new AbortController();
  }
  useEffect(() => {
    const abortController = abortControllerRef.current;
    return () => {
      abortController?.abort();
    };
  }, []);

  return abortControllerRef.current;
}
